import React from 'react';
import type { IconType } from 'react-icons';

// Properly typed icon wrapper that handles the ReactNode issue
export const IconWrapper = ({ 
  icon: IconComponent, 
  size 
}: { 
  icon: IconType; 
  size?: number 
}) => {
  // Using type assertion to bypass the TypeScript error
  const Icon = IconComponent as any;
  return <Icon size={size} />;
}; 